import { NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-portal-auth-layout',
  standalone: true,
  imports: [RouterOutlet, NgClass],
  templateUrl: './auth-layout.component.html',
  styles: [`
    .carousel-card {
      opacity: 1;
      transform: translateY(0) scale(1);
      will-change: transform, opacity;
    }
    .carousel-card.slide-animate {
      animation-name: portal-carousel-slide;
      animation-timing-function: ease-out;
      animation-duration: 300ms;
      animation-delay: 120ms;
      animation-fill-mode: both;
    }
    @keyframes portal-carousel-slide {
      from { opacity: 0; transform: translateY(14px) scale(0.985); }
      to   { opacity: 1; transform: translateY(0)   scale(1);     }
    }
  `],
})
export class PortalAuthLayoutComponent implements OnInit, OnDestroy {
  readonly currentSlide = signal(0);
  readonly animateSlide = signal(true);

  readonly slides = [
    'View and track your mortgage and protection applications.',
    'Communicate directly with your adviser in real time.',
    'Access your documents, cases, and tasks — anytime.',
  ];

  private intervalId?: ReturnType<typeof setInterval>;

  ngOnInit(): void {
    this.intervalId = setInterval(() => this.nextSlide(), 2000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  selectSlide(index: number): void {
    this.currentSlide.set(index);
    this.retriggerAnimation();
  }

  private nextSlide(): void {
    this.currentSlide.update((i) => (i + 1) % this.slides.length);
    this.retriggerAnimation();
  }

  private retriggerAnimation(): void {
    this.animateSlide.set(false);
    requestAnimationFrame(() => this.animateSlide.set(true));
  }
}
